import { render, staticRenderFns } from "./IbUserAvatar.vue?vue&type=template&id=0c664c1c&scoped=true"
import script from "./IbUserAvatar.vue?vue&type=script&lang=js"
export * from "./IbUserAvatar.vue?vue&type=script&lang=js"
import style0 from "./IbUserAvatar.vue?vue&type=style&index=0&id=0c664c1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c664c1c",
  null
  
)

export default component.exports